import { AdditionalSVGProps } from '@/models/Svg';

export const NavigationNextIcon = (
  props: React.SVGAttributes<SVGElement> & AdditionalSVGProps,
) => {
  const { className, fill = '#062747', ...rest } = props;

  return (
    <svg
      width='14'
      height='36'
      viewBox='0 0 14 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...rest}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.34933 0.769411C2.11845 0.425511 1.6525 0.333889 1.3086 0.564769C0.964695 0.795648 0.873074 1.2616 1.10395 1.6055L12.2363 18.1875L1.10395 34.7694C0.873074 35.1133 0.964696 35.5793 1.3086 35.8101C1.6525 36.041 2.11845 35.9494 2.34933 35.6055L13.7526 18.62C13.8424 18.4927 13.8896 18.341 13.8898 18.1875C13.8899 18.0806 13.8672 17.9729 13.8202 17.8719C13.8014 17.8312 13.7788 17.792 13.7527 17.755L2.34933 0.769411Z'
        fill={fill}
      />
    </svg>
  );
};
